import { useCustomerForecastCloudReport } from "../../../Customer/db";
import { useAmountInFormattedCurrency } from "../AmountInCustomerCurrency";
import { useOnNumberClick } from "../hooks";
import { LoadingCard } from "../LoadingCard";
import { TopCard } from "../TopCard";

export const ForecastSpendCard = () => {
  const forecast = useCustomerForecastCloudReport();
  const { id, number, trend, trendDirection, monthOffset } = forecast;
  const convertedNumber = useAmountInFormattedCurrency(Math.abs(Math.round(monthOffset ?? 0)));

  const { onNumberClick } = useOnNumberClick();

  if (!forecast.trendDirection) {
    return <LoadingCard title="Current month forecast" />;
  }

  const trendStr = trend
    ? `${trendDirection === "up" ? "Up" : "Down"} ${Number.isInteger(trend) ? Math.abs(trend) : Math.abs(trend).toFixed(2)}% or ${convertedNumber} vs last month`
    : "";

  return (
    <TopCard
      title="Current month forecast"
      value={number}
      trend={trendStr}
      trendColor={trendDirection === "up" ? "error.main" : "success.main"}
      dataIcon={trendDirection === "up" ? "trending up" : "trending down"}
      buttonText="Review forecast"
      items={[
        {
          title: "Review forecast",
          onClick: () => onNumberClick(id),
          eventName: "Review forecast",
          description: "Review forecast",
        },
        {
          title: "View full dashboard",
          path: "./dashboards/Pulse",
          eventName: "View full dashboard",
          description: "View full dashboard",
        },
      ]}
    />
  );
};
